export default __webpack_public_path__ + "static/media/P20016.dc1edb74.png";